<template>
    <div class="icon-module" v-if="!!params.icon_module && params.icon_module.length>0">
        <div class="module-item" v-for="(item,index) in params.icon_module" :key="index" @click="onClick(item)" :style="'width:'+(Math.floor(100/params.line))+'%'">
            <img class="module-img" :src="item.img"/>
            <span class="module-title">{{item.title}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "icon_module",
        props:{
            params:Object
        },
        methods: {
            onClick(item) {
                // this.util.carouselUrl(link);
                if(!!item.link){
                    this.$router.push(item.link);
                }else{
                    if(item.link_type=="link_url"){
                      if(item.link_url.indexOf('http')!=-1){ // 外部地址
                        location.href = item.link_url
                      }else{
                        //var url = '/mini/login/platform?user_id='+res.data.user_id+'&redirect='+encodeURIComponent(location.href)+'&token='+this.util.token;
                        this.$router.push(this.util.urlPrefix+item.link_url+'?token='+this.util.token)
                      }
                    }
                }
            },
        },
    }
</script>

<style scoped>
    .icon-module{
        flex-wrap: wrap;
        display: flex;
        align-items: center;
        min-height: 60px;
        width: 100%;
        background-color: #fff;
        margin: 16px 0;
    }
    .module-item{
        width: 25%;
        display: flex;
        height: 80px;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        cursor: pointer;
        font-size: 11px;
        flex-shrink: 0;
        overflow: hidden;
    }
    .module-img{
        width:42px;
        height:42px;
        border-radius: 30px;
        border: none;
    }
    .module-title{
        margin-top: 7.5px;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        color: #171717;
        width: 90px;
    }
</style>
